import { ref } from 'vue'
import events from './events.js'

const _vars = {
  idCounter: 0,
  notifications: ref([]),
}

function createMessageObj(type, message) {
  return {
    type: type,
    id: _vars.idCounter++,
    message: message,
  }
}

function pushInfo(message) {
  _vars.notifications.value.push(createMessageObj('info', message))
  console.log(_vars.notifications.value)

  events.trigger('pushInfo', message)
}

function pushError(message, error) {

  // Any time we show an error to the user, record it to New Relic.
  // Record the error if we have one, otherwise just the message.
  if (window.newrelic) {
    if (error) {
      window.newrelic.noticeError(error, { message })
    }
    else {
      window.newrelic.noticeError(message)
    }
  }

  _vars.notifications.value.push(createMessageObj('error', message))
  console.error(_vars.notifications.value)

  events.trigger('pushError', message)
}

function clearNotification(notificationId) {
  let _notifisObjs = _vars.notifications.value
  let index = _notifisObjs.findIndex(elem => elem.id === notificationId)
  if (index < 0) {
    return
  }
  _vars.notifications.value = _notifisObjs.toSpliced(index, 1)
}

export default {
  pushInfo,
  pushError,
  clearNotification,
  _vars,
}
